
export const GET_INCIDENT_FORM = 'GET_INCIDENT_FORM';
export const RESET_INCIDENT_FORM = 'RESET_INCIDENT_FORM';
export const POST_INCIDENT_FORM = 'POST_INCIDENT_FORM';
export const POST_INCIDENT_FORM_FAIL = 'POST_INCIDENT_FORM_FAIL';
export const POST_INCIDENT_FORM_SUCCESS = 'POST_INCIDENT_FORM_SUCCESS';



// WEBPACK FOOTER //
// ./src/types/incident.js